import axios from "axios";

const KEY = "jyvis_admin_token";
const API = process.env.REACT_APP_BACKEND_URL;

export const getAdminToken = () => localStorage.getItem(KEY);
export const setAdminToken = (t) => (t ? localStorage.setItem(KEY, t) : localStorage.removeItem(KEY));

const isAdminUrl = (url = "") => url.startsWith(`${API}/api/admin`) || url.startsWith(`${API}/api/ai/admin`)
  || url.startsWith(`${API}/api/clients`) || url.startsWith(`${API}/api/auth/admin/me`) || url.startsWith(`${API}/api/contracts/`) || url.startsWith(`${API}/api/quotes/`) || url.startsWith(`${API}/api/formation/`);

let installed = false;
export const installAdminInterceptor = (onUnauthorized) => {
  if (installed) return;
  installed = true;
  axios.interceptors.request.use((config) => {
    const token = getAdminToken();
    if (token && isAdminUrl(config.url)) config.headers.Authorization = `Bearer ${token}`;
    return config;
  });
  axios.interceptors.response.use((r) => r, (error) => {
    if (error.response?.status === 401 && isAdminUrl(error.config?.url)) {
      setAdminToken(null);
      onUnauthorized();
    }
    return Promise.reject(error);
  });
};

export const fetchAdminFile = async (fileId) => {
  const res = await axios.get(`${API}/api/admin/files/${fileId}`, { responseType: "blob" });
  window.open(URL.createObjectURL(res.data), "_blank");
};

export const fetchAdminReceipt = async (receiptId) => {
  const res = await axios.get(`${API}/api/admin/receipts/${receiptId}/pdf`, { responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.target = "_blank";
  a.download = `recu-${receiptId.slice(0, 8)}.pdf`;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 60000);
};
